import { OnInit } from '@angular/core';
import { JobService } from '../services/job.service';
import { ConfirmationService } from '../services/confirmation.service';
import { ConversationService } from '../services/conversation.service';
import { Globals } from '../objects/Globals';
import { Router } from '@angular/router';
import { ThemeSettingService } from '../services/theme-setting.service';
import { WorkspaceService } from '../services/workspace.service';
var JoblistComponent = /** @class */ (function () {
    function JoblistComponent(jobService, confirmationService, conversationService, globals, router, themeSettingService, workspaceService) {
        this.jobService = jobService;
        this.confirmationService = confirmationService;
        this.conversationService = conversationService;
        this.globals = globals;
        this.router = router;
        this.themeSettingService = themeSettingService;
        this.workspaceService = workspaceService;
        this.isBusy = true;
        this.availableImages = ['VIEWPR', 'CREATEPR', 'VIEWPO', 'CREATEPO', 'VIEWRFQ', 'CREATERFQ', 'VIEWSN', 'CREATESN', 'VIEWIV', 'CREATEIV', 'VIEWEBID', 'CREATEEBID', 'VIEWSUPPLIER', 'MANAGESUPPLIER', 'Template'];
        this.config = {
            direction: 'horizontal',
            slidesPerView: 5,
            keyboard: true,
            navigation: true,
            pagination: false,
            breakpoints: {
                // when window width is <= 480px
                380: {
                    slidesPerView: 2
                },
                768: {
                    slidesPerView: 3
                },
                // when window width is <= 480px
                992: {
                    slidesPerView: 3
                },
                1366: {
                    slidesPerView: 4
                },
                // when window width is <= 640px
                1600: {
                    slidesPerView: 5
                }
            }
        };
    }
    JoblistComponent.prototype.refreshJobListCard = function () {
        var _this = this;
        this.isBusy = true;
        if (this.componentId) {
            this.jobService.getJobList(this.componentId).subscribe(function (result) {
                var jobResult = JSON.parse(result);
                _this.jobList = jobResult.sort(_this.sortJobList);
                _this.availablePageSize = _this.jobList.length;
                _this.currentPage = 1;
                _this.isBusy = false;
            }, function (error) {
                _this.isBusy = false;
            });
        }
    };
    JoblistComponent.prototype.sortJobList = function (a, b) {
        if (a.JobOrder < b.JobOrder)
            return -1;
        if (a.JobOrder > b.JobOrder)
            return 1;
        return 0;
    };
    JoblistComponent.prototype.triggerJob = function (jobId) {
        var _this = this;
        if (jobId) {
            this.isBusy = true;
            this.jobService.triggerJob(this.componentId, jobId).subscribe(function (result) {
                var resultObject = JSON.parse(result);
                if (resultObject.ReturnType == "0") {
                    if (resultObject.Arguments) {
                        var path = [];
                        resultObject.Arguments.forEach(function (element) {
                            path.push(element);
                        });
                        ;
                        _this.router.navigate(path);
                    }
                }
                _this.isBusy = false;
            }, function (error) {
                _this.isBusy = false;
            });
        }
    };
    JoblistComponent.prototype.prevPage = function () {
    };
    JoblistComponent.prototype.nextPage = function () {
    };
    JoblistComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.loaderConfig = this.themeSettingService.getTheme();
        if (this.globals.Session) {
            this.jobService.createJobList(this.jobListType).subscribe(function (result) {
                _this.componentId = result;
                _this.refreshJobListCard();
            });
        }
    };
    JoblistComponent.prototype.pullPopup = function ($event, job) {
        var _this = this;
        this.confirmationService.confirm("Add Quick Phrase for " + job.JobName, "", ["CANCEL", "OK"], true, "Add Quick Phrase...", true)
            .subscribe(function (respond) {
            if (respond.answer == "OK") {
                //this.isBusy = true;
                _this.conversationService.saveUtteranceForJob(respond.inputText, job.JobId).subscribe(function (result) {
                    console.log(result);
                });
            }
        });
        $event.stopPropagation();
    };
    return JoblistComponent;
}());
export { JoblistComponent };
